import * as React from "react";
import Special from "../../_data/models/Special";
import * as moment from "moment";
import LikeComponent from "../../_widgets/like/LikeComponent";
import {MouseEvent} from "react";

interface Props {
    special: Special;
    toggleLike: (e: MouseEvent<HTMLElement>) => void;
    viewSpecial: () => void;
}

const ActivityFeedSpecialItemComponent = (props: Props) => {
    const {special, toggleLike, viewSpecial} = props;

    return (
        <div >
            <div className="row pr-1 pl-1" onClick={viewSpecial}>
                <div className="large-12 columns paddingless bt-1 bb-1 p2 specials">
                    <div className="text-center">
                        <h3>{special.title.toUpperCase()}</h3>
                        <p className="word-wrap-break">{special.description}</p>
                        <small>
                            Starts on {special.prettyStartDate()}
                            <br/>
                            <span>
                              {special.prettyEndDateString()}
                            </span>
                        </small>
                    </div>
                </div>
            </div>
            <div className="row p1 special-like-section">
                <div className="large-12 columns">
                    <ul className="list-inline marginless newsfeed-lgfont">
                        <LikeComponent toggleLike={toggleLike} likable={special as Likable}/>
                    </ul>
                </div>
            </div>
        </div>
    );
};
export default ActivityFeedSpecialItemComponent;


// WEBPACK FOOTER //
// ./app/client/activityFeeds/components/ActivityFeedSpecialItemComponent.tsx